import i18next from 'i18next';
import { ManualTriggerParamDataType } from '@bringg/types';
import { OptionWrapper } from '@bringg/react-components';
import { capitalizeFirstLetter } from '@bringg-frontend/utils';
import { FORM_CONTROLS } from '@bringg-frontend/dynamic-form-modal';

let fields: OptionWrapper[];

const paramTypeToFormControl: Record<ManualTriggerParamDataType, FORM_CONTROLS> = {
	[ManualTriggerParamDataType.STRING]: FORM_CONTROLS.TEXTBOX,
	[ManualTriggerParamDataType.NUMBER]: FORM_CONTROLS.INPUT,
	[ManualTriggerParamDataType.BOOLEAN]: FORM_CONTROLS.CHECKBOX,
	[ManualTriggerParamDataType.TIME]: FORM_CONTROLS.TIME,
	[ManualTriggerParamDataType.DATE]: FORM_CONTROLS.DATE,
	[ManualTriggerParamDataType.DATETIME]: FORM_CONTROLS.DATETIME,
	[ManualTriggerParamDataType.DRIVER]: FORM_CONTROLS.USER_SELECTOR
};

const getFieldControl = (fieldType: ManualTriggerParamDataType): FORM_CONTROLS => {
	return paramTypeToFormControl[fieldType];
};

export const configurationContentProvider = {
	get fields() {
		if (!fields) {
			fields = [
				{
					id: ManualTriggerParamDataType.STRING,
					name: capitalizeFirstLetter(i18next.t('AUTOMATION.TRIGGER.MANUAL.TYPES.STRING'))
				},
				{
					id: ManualTriggerParamDataType.BOOLEAN,
					name: capitalizeFirstLetter(i18next.t('AUTOMATION.TRIGGER.MANUAL.TYPES.BOOLEAN'))
				},
				{
					id: ManualTriggerParamDataType.NUMBER,
					name: capitalizeFirstLetter(i18next.t('AUTOMATION.TRIGGER.MANUAL.TYPES.NUMBER'))
				},
				{
					id: ManualTriggerParamDataType.TIME,
					name: capitalizeFirstLetter(i18next.t('AUTOMATION.TRIGGER.MANUAL.TYPES.TIME'))
				},
				{
					id: ManualTriggerParamDataType.DATE,
					name: capitalizeFirstLetter(i18next.t('AUTOMATION.TRIGGER.MANUAL.TYPES.DATE'))
				},
				{
					id: ManualTriggerParamDataType.DATETIME,
					name: capitalizeFirstLetter(i18next.t('AUTOMATION.TRIGGER.MANUAL.TYPES.DATETIME'))
				},
				{
					id: ManualTriggerParamDataType.DRIVER,
					name: capitalizeFirstLetter(i18next.t('AUTOMATION.TRIGGER.MANUAL.TYPES.DRIVER'))
				}
			];
		}

		return fields;
	},
	getFieldControl
};
